import o from"./_getNative.js";import r from"./_root.js";var t=o(r,"WeakMap");export{t as default};
//# sourceMappingURL=_WeakMap.js.map
